import { RefreshCw } from "lucide-react";
import { useUpdateAvailable } from "../hooks/useVersionCheck";

/**
 * Top-of-page banner that appears whenever a new build is available.
 * Replaces the previous bottom-right toast. Sits above all routes inside the
 * <App /> shell so every screen surfaces the update prompt consistently.
 */
export function UpdateAvailableBanner() {
  const show = useUpdateAvailable();
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="update-available-banner"
      className="sticky top-0 z-50 w-full bg-rose-800 text-white shadow-md shadow-rose-950/40 ring-1 ring-rose-500/30 animate-in slide-in-from-top duration-300"
    >
      <div className="mx-auto max-w-7xl px-4 py-2.5 flex items-center justify-center gap-3 text-sm font-medium">
        <RefreshCw className="h-4 w-4" />
        <span>New update available.</span>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="ml-1 rounded-full bg-white/15 hover:bg-white/25 text-white px-3 py-0.5 text-xs font-semibold ring-1 ring-white/20 transition-colors"
          data-testid="update-available-banner-btn"
        >
          Update now
        </button>
      </div>
    </div>
  );
}
